export default __webpack_public_path__ + "static/media/gm.26d83a6b.png";